import React, { Component } from "react";
import styles from "./app.module.scss";
import Router from "../route/router";
import { Container } from "reactstrap";
import StoreCtx from "../context/store-context";

const { StoreProvider } = StoreCtx;

class App extends Component {
  public constructor(props) {
    super(props);
  }
  public render() {
    return (
      <div className={styles.App}>
        <StoreProvider>
          <Container fluid={true} className={styles.staticView}>
            <Router></Router>
          </Container>
        </StoreProvider>
      </div>
    );
  }
}
export default App;
